import React from 'react';

import { connect } from 'react-redux';
import SidebarPanel from './SidebarPanel';
import ActionsPanelItem from './ActionsPanelItem';

import classes from './AgentActionsPanel.module.css';

const ErpAgentActionsPanel = ({
    agent,
    companyInfo,
    toggleDeleteErpAgentModal,
    toggleRenameErpAgentModal,
    toggleRotateCredentialsModal,
    syncErpAgentData
}) => {
    return (
        <SidebarPanel
            title="FSM Integration Actions"
            titleIconSrc="/assets/images/agentActionsIconColor.svg"
        >
            <div className={classes.agentActions}>
                <React.Fragment>
                    <ActionsPanelItem
                        href={`/iothub/erpagents/configure?company=${companyInfo.companyId}&erpAgent=${agent.id}`}
                        title="Configure FSM Integration"
                        iconUrl="/assets/images/basConfigIconColor.svg"
                    />
                    <ActionsPanelItem
                        title="Sync FSM Data to BOB"
                        iconUrl="/assets/images/syncIconColor.svg"
                        onClick={() => syncErpAgentData(agent.id)}
                    />
                </React.Fragment>
                <ActionsPanelItem
                    title="Rename FSM Integration"
                    iconUrl="/assets/images/erpAgentIconColor.svg"
                    onClick={() => toggleRenameErpAgentModal(true)}
                />
                <ActionsPanelItem
                    title="Rotate Integration Credentials"
                    iconUrl="/assets/images/secureIconFlat.svg"
                    onClick={() => toggleRotateCredentialsModal(true)}
                />
                <ActionsPanelItem
                    title="Delete FSM Integration"
                    iconUrl="/assets/images/deleteIconColor.svg"
                    onClick={() => toggleDeleteErpAgentModal(true)}
                />
            </div>
        </SidebarPanel>
    );
};

export default connect()(ErpAgentActionsPanel);
